import { useState } from 'react';
import HomeValueModal from '../../../components/feature/HomeValueModal';

const featuredProperties = [
  {
    id: 1,
    title: 'Modern Family Home',
    location: 'Sacramento, CA',
    price: '$725,000',
    beds: 4,
    baths: 3,
    sqft: '2,850',
    image: 'https://public.readdy.ai/ai/img_res/1fdd72f870e6f35495b5ea2a79ac4368.jpg'
  },
  {
    id: 2,
    title: 'Luxury Estate',
    location: 'Folsom, CA',
    price: '$1,250,000',
    beds: 5,
    baths: 4,
    sqft: '4,200',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20estate%20home%20with%20elegant%20architecture%2C%20upscale%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20premium%20finishes%2C%20beautiful%20landscaping%2C%20bright%20natural%20lighting&width=400&height=300&seq=featured-prop-002&orientation=landscape'
  },
  {
    id: 3,
    title: 'Charming Cottage',
    location: 'Davis, CA',
    price: '$485,000',
    beds: 3,
    baths: 2,
    sqft: '1,650',
    image: 'https://readdy.ai/api/search-image?query=Charming%20cottage%20style%20home%20with%20cozy%20exterior%2C%20residential%20property%20with%20character%2C%20professional%20real%20estate%20photography%2C%20well-maintained%20garden%2C%20inviting%20front%20porch&width=400&height=300&seq=featured-prop-003&orientation=landscape'
  },
  {
    id: 4,
    title: 'Contemporary Condo',
    location: 'Roseville, CA',
    price: '$395,000',
    beds: 2,
    baths: 2,
    sqft: '1,450',
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20condominium%20building%20with%20modern%20design%2C%20urban%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20clean%20architecture%2C%20well-maintained%20exterior&width=400&height=300&seq=featured-prop-004&orientation=landscape'
  },
  {
    id: 5,
    title: 'Spacious Ranch',
    location: 'Elk Grove, CA',
    price: '$650,000',
    beds: 4,
    baths: 2,
    sqft: '2,400',
    image: 'https://readdy.ai/api/search-image?query=Spacious%20ranch%20style%20home%20with%20single-story%20design%2C%20residential%20property%20with%20large%20yard%2C%20professional%20real%20estate%20photography%2C%20traditional%20architecture%2C%20well-maintained%20landscape&width=400&height=300&seq=featured-prop-005&orientation=landscape'
  },
  {
    id: 6,
    title: 'Waterfront Property',
    location: 'Lake Tahoe, CA',
    price: '$1,850,000',
    beds: 4,
    baths: 3,
    sqft: '3,200',
    image: 'https://readdy.ai/api/search-image?query=Waterfront%20luxury%20home%20with%20lake%20views%2C%20premium%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20beautiful%20natural%20setting%2C%20modern%20architecture%20with%20large%20windows&width=400&height=300&seq=featured-prop-006&orientation=landscape'
  }
];

export default function FeaturedSection() {
  const [showModal, setShowModal] = useState(false);
  const [showHomeValueModal, setShowHomeValueModal] = useState(false);

  return (
    <>
      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4">
          {/* Featured Widgets */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg overflow-hidden shadow-lg">
              <div className="p-8 text-white text-center">
                <h3 className="text-2xl font-bold mb-4">Featured Homes</h3>
                <button 
                  onClick={() => setShowModal(true)}
                  className="bg-white text-blue-600 px-6 py-2 rounded-md font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  View Homes
                </button>
              </div>
            </div>
            
            <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-lg overflow-hidden shadow-lg">
              <div className="p-8 text-white text-center">
                <h3 className="text-2xl font-bold mb-4">Join Our Team</h3>
                <button className="bg-white text-green-600 px-6 py-2 rounded-md font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
                  Find Out More
                </button>
              </div>
            </div>
          </div>

          {/* Two Column Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Bright%20and%20airy%20luxury%20home%20exterior%20with%20white%20or%20light-colored%20facade%2C%20beautiful%20landscaping%20with%20colorful%20flowers%2C%20sunny%20day%20photography%2C%20elegant%20residential%20property%20with%20clean%20modern%20design%2C%20well-lit%20professional%20real%20estate%20photo&width=600&height=400&seq=selling-home-light-001&orientation=landscape"
                alt="Thinking of Selling"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">Thinking of Selling?</h3>
                <p className="text-gray-600 mb-4">
                  Get your FREE Home Valuation complete with local comparables instantly.
                </p>
                <button 
                  onClick={() => setShowHomeValueModal(true)}
                  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
                >
                  Get Your Home Value
                </button>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20family%20looking%20at%20new%20home%20with%20real%20estate%20agent%2C%20home%20buying%20process%2C%20professional%20real%20estate%20consultation%2C%20modern%20residential%20property%20in%20background%2C%20positive%20home%20buying%20experience&width=600&height=400&seq=buying-home-001&orientation=landscape"
                alt="Looking to Purchase"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">Looking to Purchase?</h3>
                <p className="text-gray-600 mb-4">
                  Search thousands of current listings directly from our local MLS.
                </p>
                <a 
                  href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=1&beds=0&baths=0&min=0&max=100000000#rslt"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
                >
                  Start Your Search
                </a>
              </div>
            </div>
          </div>

          {/* Large Feature Section */}
          <div className="relative bg-white rounded-lg shadow-lg overflow-hidden mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="order-2 lg:order-1 p-8 lg:p-12 flex items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-4">Discover Luxury Listings</h2>
                  <p className="text-gray-600 mb-6 text-lg">
                    Get an insider look at these hot luxury listings within the MLS. Ask your agent about current showings!
                  </p>
                  <a 
                    href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=1&beds=0&baths=0&min=1500000&max=100000000&rtype=map#rslt"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-md hover:bg-blue-600 hover:text-white transition-colors font-medium whitespace-nowrap"
                  >
                    Learn More
                  </a>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <img 
                  src="https://readdy.ai/api/search-image?query=Luxury%20modern%20home%20exterior%20with%20elegant%20architecture%2C%20high-end%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20upscale%20neighborhood%2C%20beautiful%20landscaping%20and%20premium%20finishes%2C%20bright%20natural%20lighting&width=800&height=600&seq=luxury-home-001&orientation=landscape"
                  alt="Luxury Listings"
                  className="w-full h-80 lg:h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Featured Areas */}
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-8">Featured Areas</h2>
            <div className="bg-white rounded-lg shadow-lg p-8">
              <a 
                href="https://jefferylong.exprealty.com/index?advanced=1&rtype=map&display=Sacramento&pak=city:g30_9qce7uv6&beds=0&baths=0&min=528000&max=100000000&minacres=0&maxacres=50000&minfootage=1500&maxfootage=30000&types%5B%5D=1&styles%5B%5D=3++houses+on+lot"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl font-semibold text-blue-600 hover:text-blue-700 transition-colors"
              >
                Tahoe Park Sacramento
              </a>
            </div>
          </div>

          {/* Property Categories */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                <div className="relative bg-white rounded-lg shadow-lg overflow-hidden group cursor-pointer">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Multi-family%20residential%20building%2C%20duplex%20or%20apartment%20complex%2C%20professional%20real%20estate%20photography%2C%20modern%20multi-unit%20housing%20development%2C%20well-maintained%20property%20with%20multiple%20units&width=400&height=300&seq=multifamily-001&orientation=landscape"
                    alt="Multi Family"
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-end">
                    <div className="p-4 text-white w-full">
                      <h3 className="text-xl font-semibold mb-1">Multi Family</h3>
                      <p className="text-sm mb-2">335 Listings</p>
                      <a 
                        href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=2&beds=0&baths=0&min=0&max=100000000#rslt"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-blue-600 text-white px-4 py-1 rounded text-sm hover:bg-blue-700 transition-colors whitespace-nowrap"
                      >
                        View List
                      </a>
                    </div>
                  </div>
                </div>

                <div className="relative bg-white rounded-lg shadow-lg overflow-hidden group cursor-pointer">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Beautiful%20single%20family%20house%2C%20residential%20home%20exterior%2C%20professional%20real%20estate%20photography%2C%20suburban%20neighborhood%2C%20well-maintained%20property%20with%20front%20yard%20and%20driveway&width=400&height=300&seq=houses-001&orientation=landscape"
                    alt="Houses"
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-40 flex items-end">
                    <div className="p-4 text-white w-full">
                      <h3 className="text-xl font-semibold mb-1">Houses</h3>
                      <p className="text-sm mb-2">8185 Listings</p>
                      <a 
                        href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=1&beds=0&baths=0&min=0&max=100000000#rslt"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-blue-600 text-white px-4 py-1 rounded text-sm hover:bg-blue-700 transition-colors whitespace-nowrap"
                      >
                        View List
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative bg-white rounded-lg shadow-lg overflow-hidden group cursor-pointer">
                <img 
                  src="https://readdy.ai/api/search-image?query=Bright%20and%20vibrant%20modern%20condominium%20complex%20with%20colorful%20exterior%20design%2C%20contemporary%20architecture%20with%20bold%20accent%20colors%2C%20sunny%20day%20photography%2C%20well-maintained%20property%20with%20attractive%20landscaping%20and%20modern%20amenities&width=600&height=300&seq=condos-bright-001&orientation=landscape"
                  alt="Condos"
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-end">
                  <div className="p-4 text-white w-full">
                    <h3 className="text-xl font-semibold mb-1">Condos</h3>
                    <p className="text-sm mb-2">627 Listings</p>
                    <a 
                      href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=3&beds=0&baths=0&min=0&max=100000000#rslt"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-blue-600 text-white px-4 py-1 rounded text-sm hover:bg-blue-700 transition-colors whitespace-nowrap"
                    >
                      View List
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="relative bg-white rounded-lg shadow-lg overflow-hidden group cursor-pointer h-full">
                <img 
                  src="https://readdy.ai/api/search-image?query=Large%20residential%20house%20lot%20with%20spacious%20yard%20and%20mature%20trees%2C%20premium%20buildable%20land%20for%20luxury%20home%20construction%2C%20well-maintained%20property%20with%20utilities%20available%2C%20investment%20opportunity%20for%20custom%20home%20development&width=600&height=400&seq=house-lot-001&orientation=landscape"
                  alt="Land"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-end">
                  <div className="p-4 text-white w-full">
                    <h3 className="text-xl font-semibold mb-1">Land</h3>
                    <p className="text-sm mb-2">2519 Listings</p>
                    <a 
                      href="https://jefferylong.exprealty.com/index.php?advanced=1&display=&custombox=&types[]=5&beds=0&baths=0&min=0&max=100000000#rslt"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-blue-600 text-white px-4 py-1 rounded text-sm hover:bg-blue-700 transition-colors whitespace-nowrap"
                    >
                      View List
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Home Value Modal */}
      <HomeValueModal isOpen={showHomeValueModal} onClose={() => setShowHomeValueModal(false)} />

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-lg max-w-6xl w-full max-h-[90vh] overflow-hidden" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="bg-blue-600 text-white px-6 py-4 flex items-center justify-between">
              <h2 className="text-2xl font-bold">Featured Properties</h2>
              <button 
                onClick={() => setShowModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-blue-700 rounded-full transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* All Featured Properties */}
                {featuredProperties.map((property) => (
                  <div key={property.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                    <div className="relative h-48">
                      <img 
                        src={property.image} 
                        alt={property.title}
                        className="w-full h-full object-cover object-top"
                      />
                      <div className="absolute top-3 right-3 bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                        {property.price}
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="font-bold text-lg mb-2 text-gray-800">{property.title}</h3>
                      <p className="text-gray-600 text-sm mb-3 flex items-center">
                        <i className="ri-map-pin-line mr-1"></i>
                        {property.location}
                      </p>
                      <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
                        <span className="flex items-center">
                          <i className="ri-hotel-bed-line mr-1"></i>
                          {property.beds} Beds
                        </span>
                        <span className="flex items-center">
                          <i className="ri-drop-line mr-1"></i>
                          {property.baths} Baths
                        </span>
                        <span className="flex items-center">
                          <i className="ri-ruler-line mr-1"></i>
                          {property.sqft} sqft
                        </span>
                      </div>
                      <a 
                        href="https://jefferylong.exprealty.com/index.php?showagent=1&rtype=map"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block w-full bg-blue-600 text-white text-center px-4 py-2 rounded hover:bg-blue-700 transition-colors whitespace-nowrap"
                      >
                        View Details
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}